export const validateRule = Object.freeze({
  EMAIL: /(?=^.{6,40}$)^[-\w]+(\.[-\w]+)*@[-\w]+(\.[-\w]+)+$/,
})
